import { render, staticRenderFns } from "./SFormClientComp.vue?vue&type=template&id=7de24ef6&"
import script from "./SFormClientComp.vue?vue&type=script&lang=js&"
export * from "./SFormClientComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports